import * as React from 'react';
import { StockLandingSubmitFormFragment } from './__generated__/StockLandingSubmitFormFragment';
import { ActualForm } from './ActualForm';
import { Stocks_StockStatus } from '../../../../../__generated__/globalTypes';
import { useTranslation } from 'react-i18next';

interface Props {
  product: StockLandingSubmitFormFragment;
}

export const SubmitForm: React.FC<Props> = ({ product }) => {
  const { t } = useTranslation();
  return (
    <>
      <h2 className="invest-landing-section__title">
        {t('Invest in')} {product.title}
      </h2>
      <ActualForm
        id={product.id}
        symbol={product.symbol}
        disabled={product.status !== Stocks_StockStatus.PUBLISHED}
      />
    </>
  );
};
